import React, { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const BestSelling = () => {
        const revealRefs = useRef([]);
    
        const addRevealRef = useCallback((el) => {
            if (el && !revealRefs.current.includes(el)) {
                revealRefs.current.push(el);
            }
        }, []);
        useEffect(() => {    
            // GSAP Reveal Animation
            revealRefs.current.forEach((container) => {
                const image = container.querySelector('img');
    
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        toggleActions: 'play none none none',
                    },
                });
    
                tl.set(container, { autoAlpha: 1 });
    
                tl.from(container, {
                    // xPercent: -100,
                    duration: 1,
                    ease: 'power2.out',
                });
    
                tl.from(image, {
                    xPercent: 100,
                    scale: 1,
                    delay: -1,
                    duration: 1,
                    ease: 'power2.out',
                });
            });
        }, []);
    
    return (
        <>
            <div className="best-selling">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            {/* Best Seeling Content Start */}
                            <div className="best-selling-content">
                                {/* Best Seeling Content Image Start */}
                                <div className="best-selling-content-img">
                                    <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                        <img src="images/best-selling-img-1.jpg" alt="" />
                                    </figure>
                                </div>
                                {/* Best Seeling Content Image End */}
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp" style={{ fontSize: 25 }}>
                                        best selling finishes
                                    </h3>
                                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                                        We use materials only from personally{" "}
                                        <span>verified suppliers</span>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        Gloss, matte wood texture, 200+ colors to choose from.
                                        Environmentally friendly materials, all plywood&nbsp;etc are
                                        available.
                                    </p>
                                </div>
                                {/* Section Title End */}
                            </div>
                            {/* Best Seeling Content End */}
                        </div>
                        <div className="col-lg-6">
                            {/* Best Seeling Image Start */}
                            <div className="best-selling-iamge">
                                <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                    <img src="images/best-selling-img-2.jpg" alt="" />
                                </figure>
                            </div>
                            {/* Best Seeling Image End */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BestSelling
